import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { IMainState } from 'store/states'
import * as fromActions from 'store/actions/lessons.action'
import { IEvaluationResume } from 'models/evaluation.model'
import ContentBlock from './components/ContentBlock'

export interface Props {
  currentLesson?: any
  setMandatoriesRef?: (elements: (HTMLElement | null)[]) => void
  canEdit: boolean
  onEvaluation: boolean
  setOnEvaluation: (value: boolean) => void
  evaluation: IEvaluationResume | null
  setEvaluation: (value: IEvaluationResume) => void
  onRefreshLessonContent?: () => void
}

interface Params {
  courseId: string
}

const LessonCard: React.FC<Props> = ({
  setMandatoriesRef,
  canEdit,
  onEvaluation,
  setOnEvaluation,
  currentLesson,
  evaluation,
  setEvaluation,
  onRefreshLessonContent,
}) => {
  const dispatch = useDispatch()
  const [lessonData, setLessonData] = useState({} as any)
  const [currentLessonData, setCurrentLessonData] = useState({} as any)
  const { lesson } = useSelector(({ lmsLessons }: IMainState) => lmsLessons)

  const { courseId } = useParams<Params>()

  useEffect(() => {
    return () => {
      setCurrentLessonData({})
      setLessonData({})
    }
  }, [])

  useEffect(() => {
    if (currentLesson && currentLesson.id !== currentLessonData.id)
      setCurrentLessonData(currentLesson)
  }, [currentLesson, currentLessonData.id])

  useEffect(() => {
    setLessonData({})
    if (currentLessonData.id)
      dispatch({
        type: fromActions.LESSONS_GET_LESSON,
        payload: currentLessonData.id,
      })
  }, [currentLessonData, dispatch])

  useEffect(() => {
    if (
      lesson &&
      lesson.blockInstances &&
      !!lesson.blockInstances.length &&
      lesson.courseId === Number(courseId)
    )
      setLessonData({ id: lesson.id, blockInstances: lesson.blockInstances })
  }, [courseId, lesson])

  return (
    <>
      {lessonData.id && (
        <ContentBlock
          lessonId={lessonData.id}
          canEdit={canEdit}
          onEvaluation={onEvaluation}
          setOnEvaluation={setOnEvaluation}
          evaluation={evaluation}
          setEvaluation={setEvaluation}
          blockInstances={lessonData.blockInstances}
          setMandatoriesRef={setMandatoriesRef}
          onRefreshLessonContent={onRefreshLessonContent}
        />
      )}
    </>
  )
}

export default LessonCard
export * from './components'
